import React from 'react';
import { Box, Checkbox, Typography, Tooltip, IconButton } from '@mui/material';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import { makeStyles, styled } from '@mui/styles';
import { createTheme } from '@mui/material/styles';
const theme = createTheme();
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import DataSocialResCard from './dataSocialResCard';
import completedSvg from '../../assets/images/completedSvg.svg';
import notCompletedSvg from '../../assets/images/notCompletedSvg.svg';
import rejectSvg from '../../assets/images/rejectSvg.svg';
import notRejectSvg from '../../assets/images/notRejectSvg.svg';
import CircleIcon from '@mui/icons-material/Circle';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';

const useStyles = makeStyles(() => ({
    cardContent: {
        padding: 0,
        '&:last-child': {
            paddingBottom: 0,
        },
    },
    headRowContent: {
        display: 'flex',
        flexWrap: 'wrap',
        maxWidth: '100%',
        width: '100%',
        alignItems: 'center',
    },
    rowContent: {
        display: 'flex',
        flexWrap: 'wrap',
        maxWidth: '100%',
        width: '100%',
    },
    actionIcon: {
        width: 20,
    },
    listItemContent: {
        padding: theme.spacing(1, 0),
    },
    paperContent: {
        boxShadow: 'none',
        borderRadius: 0,
        padding: theme.spacing(2, 1, 0, 1),
        backgroundColor: '#fff',
    },
}));

const Accordion = styled((props) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))(() => ({
    // border: `1px solid ${theme.palette.divider}`,
    zIndex: 0,
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    // boxShadow:
    //     'rgb(145 158 171 / 24%) 0px 0px 2px 0px, rgb(145 158 171 / 24%) 0px 16px 32px -4px',
    boxShadow: 'rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px',
    borderRadius: theme.spacing(0.5),
    '&:not(:last-child)': {
        borderBottom: 0,
    },
    '&:before': {
        display: 'none',
    },
}));

const AccordionSummary = styled((props) => (
    <MuiAccordionSummary expandIcon={<ArrowForwardIosSharpIcon />} {...props} />
))(() => ({
    //backgroundColor: '#f5f5f5',
    //flexDirection: 'row-reverse',
    padding: theme.spacing(1),
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        transform: 'rotate(180deg)',
    },
    '& .MuiAccordionSummary-content': {
        margin: theme.spacing(0),
    },
}));

const AccordionDetails = styled(MuiAccordionDetails)(() => ({
    padding: theme.spacing(0, 2, 1, 2),
    borderTop: '1px solid rgba(0, 0, 0, .125)',
}));

const DataSocialResRow = (props) =>
{
    const classes = useStyles();
    const { item, index } = props;
    const [expand, setExpanded] = React.useState(false);

    return (
        <Accordion expanded={expand}>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon onClick={() => setExpanded(!expand)} />}

                aria-controls="panel1a-content"
                id="panel1a-header">
                <Box className={classes.headRowContent}>
                    <Box
                        sx={{
                            width: '10%',
                            flexBasis: '10%',
                            flexGrow: 1,
                        }}>
                        <Checkbox
                            inputProps={{
                                'aria-label': 'SocialResponsibility',
                            }}
                            checked={item.selected ? item.selected : false}
                            onChange={(event) =>
                                props.onCheckSelect(event, index)
                            }
                            // color="secondary"
                            value={item.actualData.socialResponsibilityID}
                        />
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'left',
                            alignItems: 'start',
                            width: '20%',
                            flexBasis: '20%',
                            flexGrow: 1,
                        }}>
                        <Typography
                            variant="h4"
                            // flexGrow={1}
                            fontSize={12}
                            fontWeight={500}
                            color="primary"></Typography>
                        <Typography
                            variant="h4"
                            // flexGrow={1}
                            fontSize={14}
                            fontWeight={400}>
                            {item.actualData.participant.search('DELETED') !==
                                -1 && (
                                    <span
                                        style={{ color: 'red' }}>{`DELETED`}</span>
                                )}
                            {item.actualData.participant.replace('DELETED', '')}
                        </Typography>
                        <Typography
                            fontSize={11}
                            sx={{
                                display: '-webkit-box',
                                boxOrient: 'vertical',
                                lineClamp: 2,
                                wordBreak: 'break-all',
                                overflow: 'hidden',
                                pr: 1,
                            }}>
                            <a href={`mailto:${item.actualData.email}`}>
                                {' '}
                                {item.actualData.email}{' '}
                            </a>
                        </Typography>
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'left',
                            alignItems: 'start',
                            width: '20%',
                            flexBasis: '20%',
                            flexGrow: 1,
                        }}>
                        <Typography
                            variant="h4"
                            // flexGrow={1}
                            fontSize={12}
                            fontWeight={500}
                            color="primary">
                            Submitted By
                        </Typography>
                        <Typography
                            variant="h4"
                            // flexGrow={1}
                            fontSize={14}
                            fontWeight={400}>
                            <span>{item.actualData.createdByName}</span>
                        </Typography>
                    </Box>
                    <Tooltip title="Change Log" aria-label="changelog">
                        <IconButton
                            color="primary"
                            onClick={() => props.showHistory(item)}
                            disabled={
                                item.disableRow != undefined
                                    ? item.disableRow
                                    : false
                            }>
                            <VisibilityOutlinedIcon
                                fontSize="small"
                                color={
                                    item.disableRow != undefined
                                        ? 'default'
                                        : 'primary'
                                }
                            />
                        </IconButton>
                    </Tooltip>
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'left',
                        alignItems: 'center',
                        width: '2%',
                        flexBasis: '2%',
                        flexGrow: 1,
                    }}>
                        <Typography
                            variant="h4"
                            // flexGrow={1}
                            fontSize={12}
                            fontWeight={500}
                            color="primary">
                            Status
                        </Typography>
                        <Tooltip title="Status" aria-label="Status">
                            <CircleIcon
                                fontSize="small"
                                style={{
                                    color:
                                        item.actualData.requestStatus == 'Pending'
                                            ? '#F9B811'
                                            : item.actualData.requestStatus == 'Approved'
                                                ? '#169D3C'
                                                : '#C81020',
                                }}
                            />
                        </Tooltip>
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'row-reverse',
                            justifyContent: 'end',
                            alignItems: 'center',
                            width: '10%',
                            flexBasis: '10%',
                            flexGrow: 1,
                        }}>
                        {props.showEdit && (
                            <Tooltip title="Edit" aria-label="edit">
                                <IconButton
                                    color="primary"
                                    onClick={() => props.editRow(item)}>
                                    <EditOutlinedIcon
                                        fontSize="small"
                                        color={'primary'}
                                    />
                                </IconButton>
                            </Tooltip>
                        )}
                        <Tooltip title="Reject" aria-label="Reject">
                            <IconButton
                                color="primary"
                                onClick={() =>
                                {
                                    item.actualData.requestStatus ==
                                        'Pending' ||
                                        item.actualData.requestStatus == 'Approved'
                                        ? props.onActionClick(item, 'Reject')
                                        : props.onPendingAction(item);
                                }}
                                sx={
                                    item.actualData.requestStatus == 'Pending'
                                        ? { cursor: 'pointer' }
                                        : item.actualData.requestStatus ==
                                            'Rejected'
                                            ? { cursor: 'default' }
                                            : { cursor: 'pointer' }
                                }>
                                <Box
                                    component="img"
                                    className={classes.actionIcon}
                                    alt="logo."
                                    src={
                                        item.actualData.requestStatus ==
                                            'Pending'
                                            ? notRejectSvg
                                            : item.actualData.requestStatus ==
                                                'Approved'
                                                ? notRejectSvg
                                                : rejectSvg
                                    }
                                />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Approve" aria-label="Approve">
                            <IconButton
                                color="primary"
                                onClick={() =>
                                {
                                    item.actualData.requestStatus ==
                                        'Pending' ||
                                        item.actualData.requestStatus == 'Rejected'
                                        ? props.onActionClick(item, 'Approve')
                                        : props.onPendingAction(item);
                                }}
                                sx={
                                    item.actualData.requestStatus == 'Pending'
                                        ? { cursor: 'pointer' }
                                        : item.actualData.requestStatus ==
                                            'Approved'
                                            ? { cursor: 'default' }
                                            : { cursor: 'pointer' }
                                }>
                                <Box
                                    component="img"
                                    className={classes.actionIcon}
                                    alt="logo."
                                    src={
                                        item.actualData.requestStatus ==
                                            'Pending'
                                            ? notCompletedSvg
                                            : item.actualData.requestStatus ==
                                                'Approved'
                                                ? completedSvg
                                                : notCompletedSvg
                                    }
                                />
                            </IconButton>
                        </Tooltip>
                    </Box>
                </Box>
            </AccordionSummary>
            <AccordionDetails>
                <DataSocialResCard
                    classes={classes}
                    item={item}
                    index={index}
                    {...props}
                />
            </AccordionDetails>
        </Accordion>
        // <ListItem className={classes.listItemContent}>
        //     <DataOutfitCard
        //         classes={classes}
        //         item={item}
        //         index={index}
        //         {...props}
        //     />
        // </ListItem>
    );
};

export default DataSocialResRow;
